<div class="container">
  <div class="careers">
    <h1 class="careers__header">Careers for life</h1>
    <div class="careers__content">
      <div nz-row [nzGutter]="[16, 16]">
        @for (box of siteData.lander.careersForLife.boxes; track box) {
          <div
            nz-col
            nzXs="24"
            nzSm="12"
            nzMd="12"
            nzLg="6"
            >
            <div
              class="careers__content-item {{ box.className }}"
              [style]="{ 'background-image': 'url(' + box.image + ')' }"
              >
              <div class="item-holder">
                <h1>{{ box.header }}</h1>
                <button
                  nz-button
                  nzType="primary"
                  nzShape="round"
                  nzSize="large"
                  [routerLink]="box.link.routerLink"
                  [queryParams]="addQueryParams(box.link.queryParams)"
                  >
                  {{ box.link.text }}
                </button>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
